// src/button/src/button.styles.ts
import { cva } from "class-variance-authority";
var buttonVariants = cva(
  "btn-focus box-border inline-flex h-11 w-fit min-w-24 max-w-full cursor-pointer justify-center rounded border px-4 text-sm-strong hover:no-underline",
  {
    compoundVariants: [
      // Button / primary
      {
        className: "border-interactive-primary bg-interactive-primary hover:border-interactive-primary-alt hover:bg-interactive-primary-alt focus:border-interactive-primary-light active:border-interactive-primary-light active:bg-interactive-primary-alt active:ring-interactive-primary-alt",
        destructive: false,
        disabled: false,
        variant: "primary"
      },
      // Button / primary / destructive
      {
        className: "bg-state-negative-text text-surface-light hover:bg-state-negative-graphics active:bg-state-negative-graphics active:ring-state-negative-graphics",
        destructive: true,
        disabled: false,
        variant: "primary"
      },
      // Button / secondary
      {
        className: "border-surface-border text-surface-dark active:border-interactive-focus active:bg-surface-subtle",
        destructive: false,
        disabled: false,
        variant: "secondary"
      },
      // Button / secondary / destructive
      {
        className: "border-surface-border active:border-surface-border active:bg-surface-subtle",
        destructive: true,
        disabled: false,
        variant: "secondary"
      },
      // Button / text
      {
        className: "text-interactive-secondary hover:border-transparent hover:bg-surface-subtle active:border-interactive-secondary active:bg-surface-subtle",
        destructive: false,
        disabled: false,
        variant: "text"
      },
      // Button / text / destructive
      {
        className: "active:state-negative-text hover:bg-surface-subtle active:border-state-negative-text active:bg-surface-subtle",
        destructive: true,
        disabled: false,
        variant: "text"
      },
      // Shared
      {
        className: "text-state-negative-text",
        destructive: true,
        variant: ["secondary", "text"]
      },
      // Button / primary - disabled
      {
        className: "!bg-interactive-disabled",
        destructive: false,
        disabled: true,
        variant: "primary"
      },
      // Button / secondary - disabled
      {
        className: "!border-interactive-disabled !text-interactive-disabled",
        destructive: false,
        disabled: true,
        variant: "secondary"
      },
      // Button / text - disabled
      {
        className: "!text-interactive-disabled",
        destructive: false,
        disabled: true,
        variant: "text"
      },
      // Button / primary / destructive - disabled
      {
        className: "!bg-state-negative-background",
        destructive: true,
        disabled: true,
        variant: "primary"
      },
      // Button / secondary / destructive - disabled
      {
        className: "!border-interactive-disabled !text-state-negative-background",
        destructive: true,
        disabled: true,
        variant: "secondary"
      },
      // Button / text / destructive - disabled
      {
        className: "!text-state-negative-background",
        destructive: true,
        disabled: true,
        variant: "text"
      }
    ],
    variants: {
      busy: {
        false: "",
        true: ""
      },
      destructive: {
        false: "",
        true: ""
      },
      disabled: {
        true: "pointer-events-none"
      },
      fullWidth: {
        true: "w-full justify-center text-center"
      },
      variant: {
        primary: "text-interactive-primary-light active:ring-1",
        secondary: "hover:bg-surface-subtle active:ring-transparent",
        text: "border-transparent active:ring-1 active:ring-transparent"
      }
    }
  }
);

export {
  buttonVariants
};
